import React, { useEffect, useRef, useState } from 'react';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { useQuery } from 'react-query';
import { useReactToPrint } from 'react-to-print';
import Loader from '../../../Shared/Loader';
import person from '../../../../assets/images/person.jpeg'
import ImageModal from '../../../Shared/ImageModal';


const CustomerDueReport = () => {
    const [customers, setCustomers] = useState([]);
    const [searchResult, setSearchResult] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const componentRef = useRef()
    const [selectedImage, setSelectedImage] = useState(null);

    const generatePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: `Cash Statement`,

    });

    useEffect(() => {
        const url = `https://servers.thakurgaonexpress.com/rupkotha/customerduereport`
        fetch(url)
            .then(res => res.json())
            .then(data => {
                const filtered = data?.customerDues.filter(due => due.balance !== 0)
                setCustomers(filtered);
                console.log(data?.customerDues);
                setIsLoading(false)
            })
    }, []);


    if (isLoading) {
        return <Loader></Loader>
    }

    const handleSearchResult = (event) => {
        const searchText = event.target.value;
        const match = customers.filter(customer => customer.name.includes(searchText) || customer.name.toLowerCase().includes(searchText)
            || customer.name.toUpperCase().includes(searchText));
        setSearchResult(match);
        setIsSearching(true);
    }

    const totalBalance = isSearching ? searchResult.reduce((total, currentValue) => total + parseFloat(currentValue.balance), 0) :
        customers.reduce((total, currentValue) => total + parseFloat(currentValue.balance), 0);

    return (
        <div className='mx-2'>
            <h1 className='text-center text-lg mt-8'>Customer Due Report</h1>
            <div className='text-right mt-12'>
                <ReactHtmlTableToExcel
                    id="test-table-xls-button"
                    className="btn btn-error text-white btn-xs mt-2 lg:mt-0"
                    table="table-to-xls"
                    filename={`Balance Sheet`}
                    sheet={`balance-sheet`}
                    buttonText="Export to exel" />
                <button className='btn btn-success btn-xs ml-2 text-white' onClick={generatePrint}>Print</button>
            </div>
            <div className='flex lg:justify-end justify-center items-center mt-4'>
                <div class="form-control w-60">
                    <input onChange={handleSearchResult} type="text" placeholder="Search Customer" class="input text-xs input-bordered bg-white input-error w-full max-w-xs" />
                </div>
            </div>
            <div ref={componentRef} class="overflow-x-auto">
                <table id='table-to-xls' class="table w-1/2 mx-auto text-xs mb-20">
                    <caption className='text-center text-lg mb-2 mt-16'>Customers Due Report</caption>
                    <thead>
                        <tr className='text-center'>
                            <th className='bg-primary text-white normal-case'>SL</th>
                            <th className='bg-primary text-white normal-case'>Image</th>
                            <th className='bg-primary text-white normal-case'>Customer Code </th>
                            <th className='bg-primary text-white normal-case'>Customer Name</th>
                            <th className='bg-primary text-white normal-case'>Address</th>
                            <th className='bg-primary text-white normal-case'>Phone</th>
                            <th className='bg-primary text-white normal-case'>Opening Balance</th>
                            <th className='bg-primary text-white normal-case'>Total Sales</th>
                            <th className='bg-primary text-white normal-case'>Total Sales Return</th>
                            <th className='bg-primary text-white normal-case'>Total Collection</th>
                            <th className='bg-primary text-white normal-case'>Balance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            isSearching ? searchResult.map((customer, index) => <tr className='text-center'>
                                <td>{index + 1}</td>
                                <td>
                                    <label className='cursor-pointer' for="image-modal" onClick={() => setSelectedImage(customer?.img ? customer?.img : person)}>
                                        <img src={customer?.img ? customer?.img : person} alt="Customer Image" />
                                    </label>
                                </td>
                                <td>{customer?.customerCode}</td>
                                <td>{customer?.name}</td>
                                <td>{customer?.address}</td>
                                <td>{customer?.phone}</td>
                                <td className='text-blue-800'>{customer?.opening}</td>
                                <td className='text-green-600'>{customer?.totalSale}</td>
                                <td className='text-green-600'>{customer?.totalReturnSales}</td>
                                <td className='text-yellow-700'>{customer?.totalCollection}</td>
                                <td className='text-primary font-bold'>{customer?.balance}</td>
                            </tr>) : customers.map((customer, index) => <tr className='text-center'>
                                <td>{index + 1}</td>
                                <td>
                                    <label className='cursor-pointer' for="image-modal" onClick={() => setSelectedImage(customer?.img ? customer?.img : person)}>
                                        <img src={customer?.img ? customer?.img : person} alt="Customer Image" />
                                    </label>
                                </td>
                                <td>{customer?.customerCode}</td>
                                <td>{customer?.name}</td>
                                <td>{customer?.address}</td>
                                <td>{customer?.phone}</td>
                                <td className='text-blue-800'>{customer?.opening}</td>
                                <td className='text-green-600'>{customer?.totalSale}</td>
                                <td className='text-green-600'>{customer?.totalReturnSales}</td>
                                <td className='text-yellow-700'>{customer?.totalCollection}</td>
                                <td className='text-primary font-bold'>{customer?.balance}</td>
                            </tr>)
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'>Total Dues</th>
                            <th className='bg-primary text-white normal-case'>{totalBalance}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
            {selectedImage && (
                <ImageModal selectedImage={selectedImage} setSelectedImage={setSelectedImage} />
            )}
        </div>
    );
};

export default CustomerDueReport;